import { StoreMemoryService } from "./storeMemory.service";
import { StoreSessionService } from "./storeSession.service";

export * from "./storeMemory.service";
export * from "./storeSession.service";

export const StoreServicesImports = [
  StoreMemoryService,
  StoreSessionService,
]